import React from 'react';

// @ts-ignore
import AmexIconSvg from '../../assets/images/cards/Amex.svg';
// @ts-ignore
import MastercardIconSvg from '../../assets/images/cards/Mastercard.svg';
// @ts-ignore
import VisaIconSvg from '../../assets/images/cards/Visa.svg';
// @ts-ignore
import FPXIconSvg from '../../assets/images/fpx/fpx.svg';
// @ts-ignore
import DeleteIconSvg from '../../assets/images/icons/delete.svg';
// @ts-ignore
import LockIconSvg from '../../assets/images/icons/lock.svg';
// @ts-ignore
import SaveTimeIconSvg from '../../assets/images/icons/savetime.svg';
// @ts-ignore
import StripeNotLoaded from '../../assets/images/icons/stripenotloaded.svg';

// convert svg to function in https://svg2jsx.com/

export function IconVisa() {
  return (
    <span data-name="Visa" dangerouslySetInnerHTML={{ __html: VisaIconSvg }} />
  );
}

export function IconMastercard() {
  return (
    <span
      data-name="Mastercard"
      dangerouslySetInnerHTML={{ __html: MastercardIconSvg }}
    />
  );
}

export function IconAmex() {
  return (
    <span data-name="Amex" dangerouslySetInnerHTML={{ __html: AmexIconSvg }} />
  );
}

export function IconFPX() {
  return <span dangerouslySetInnerHTML={{ __html: FPXIconSvg }} />;
}

export function IconLock() {
  return <span dangerouslySetInnerHTML={{ __html: LockIconSvg }} />;
}

export function IconDelete() {
  return <span dangerouslySetInnerHTML={{ __html: DeleteIconSvg }} />;
}

export function IconSaveTime() {
  return <span dangerouslySetInnerHTML={{ __html: SaveTimeIconSvg }} />;
}

export function IconStripeNotLoaded() {
  return <span dangerouslySetInnerHTML={{ __html: StripeNotLoaded }} />;
}
